module.exports = {
          srcSet: __webpack_public_path__ + "2d9e6eae15f72fdafa85154dcc11c895-25.png"+" 25w",
          images:[ {path: __webpack_public_path__ + "2d9e6eae15f72fdafa85154dcc11c895-25.png",width: 25,height: 25}],
          src: __webpack_public_path__ + "2d9e6eae15f72fdafa85154dcc11c895-25.png",
          toString:function(){return __webpack_public_path__ + "2d9e6eae15f72fdafa85154dcc11c895-25.png"},
          
          width: 25,
          height: 25
        }